import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FeatureFlagsConfig } from '../feature-flags.config';

@Component({
    selector: 'app-flag',
    templateUrl: './flag.component.html',
    styleUrls: ['./flag.component.css']
})
export class FlagComponent implements OnInit {
    @Input() key!: string;
    @Input() modified = false;
    @Input() active = false;
    @Input() helpText?: string;

    @Output() toggled = new EventEmitter<void>();

    private readonly JIRA_LINK_PREFIX = 'https://jira.amer.thermo.com/browse/';
    private readonly JIRA_TICKET_REGEX = /\bINTGPT-\d+\b/;

    readonly HELP_ICON_COLOR = {
        DEFAULT: '#6c757d',
        ACTIVE: '#0071D0',
    };

    jiraLink?: string;

    disabledToggleFlags = FeatureFlagsConfig.disabledToggleFlags;
    warningFlagInfo = FeatureFlagsConfig.warningFlagInfo;

    ngOnInit(): void {
        this.setJiraLink();
    }

    setJiraLink(): void {
        if (!this.helpText) {
            return;
        }

        const jiraMatches = this.helpText.match(this.JIRA_TICKET_REGEX);

        if (jiraMatches && jiraMatches.length > 0) {
            const jiraTicket = jiraMatches[0];
            this.jiraLink = `${this.JIRA_LINK_PREFIX}${jiraTicket}`;
        }
    }

    goToJiraIssue(): void {
        if (this.jiraLink) {
            window.open(this.jiraLink, '_blank');
        }
    }

    get helpIconColor(): string {
        if (this.jiraLink) {
            return this.HELP_ICON_COLOR.ACTIVE;
        }

        return this.HELP_ICON_COLOR.DEFAULT;
    }

    onToggle() {
        this.toggled.emit();
    };

    get isDisabled(): boolean {
        return this.disabledToggleFlags[this.key] !== undefined;
    }

    get hasWarning(): boolean {
        return this.warningFlagInfo[this.key] !== undefined;
    }
}